import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { JobFiltersEventHandler } from '@ClientBase/Generic/JobFiltersEventHandler'
import { PostFiltersEventHandler } from '@ClientBase/Generic/PostFiltersEventHandler'
import { BurgerMenuEventHandler } from '@ClientBase/Generic/BurgerMenuEventHandler'
import * as Carousels from './Carousels'
import * as VideoSnippet from './VideoSnippet'
import * as DomMainipulations from './DomMainipulations'
import * as Navigation from './Navigation'
import * as SearchOverlay from './SearchOverlay'
import * as Filters from './Filters'
import * as StickyApply from './StickyApply'
import * as JobTile from './JobTile'
import * as Modal from './Modal'
import * as PostTile from './PostTile'
import * as ListWidget from './ListWidget'
import * as SocialProfile from './SocialProfileWidget'
import * as Footer from './Footer'
import SnippetSpacer from './Spacer/Spacer'
import SnippetHeading from './Heading/Heading'
import SnippetContent from './Content/Content'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetTabSwitcher from './TabSwitcher/TabSwitcher'
import SnippetIconsText from './IconsText/IconsText'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetVideo from './Video/Video'
import SnippetRecruitmentProcess from './RecruitmentProcess/RecruitmentProcess';
import SnippetKeyFigures from './KeyFigures/KeyFigures';
import SnippetContentCta from './ContentCta/ContentCta';
import SnippetContentColumnAlt from './ContentColumnAlt/ContentColumnAlt';
import {applicationLoadingSpinner, showAuthorDetailsIfAuthor} from "./DomMainipulations";
import {closeVideoModal, initializeVideoBannerModal} from './VideoModal'

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const _Components = {
    'SnippetSpacer': SnippetSpacer,
    'SnippetHeading': SnippetHeading,
    'SnippetContent' : SnippetContent,
    'SnippetImageContent': SnippetImageContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetTabSwitcher': SnippetTabSwitcher,
    'SnippetIconsText' : SnippetIconsText,
    'SnippetAccordion' : SnippetAccordionReact,
    'SnippetVideo' : SnippetVideo,
    'SnippetRecruitmentProcess': SnippetRecruitmentProcess,
    'SnippetKeyFigures': SnippetKeyFigures,
    'SnippetContentCta': SnippetContentCta,
    'SnippetContentColumnAlt': SnippetContentColumnAlt,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Navigation.navigationFunctions()
        DomMainipulations.removeSocialWidgetIfEmpty()
        JobFiltersEventHandler.useAttraxTsHandlers($)
        PostFiltersEventHandler.useAttraxTShandler($)
        BurgerMenuEventHandler.handleClickEvents($)
        VideoSnippet.VideoClickHandler()
        DomMainipulations.moveLinkedInButton($)
        DomMainipulations.moveFilterButton($)
        DomMainipulations.repositionBioModal($)
        DomMainipulations.shortlistRedirect($)
        DomMainipulations.showValidationIfTrue($)
        DomMainipulations.moveKeyword()
        DomMainipulations.moveSendCvModal($)
        DomMainipulations.removeFooterAutocomplete($)
        DomMainipulations.showExpiredVacancyBanner($)
        DomMainipulations.removeNonBreakingSpaceFromJobDetails()
        DomMainipulations.addFilterTextHeadingJobResults()
        DomMainipulations.showAuthorDetailsIfAuthor()
        DomMainipulations.applicationLoadingSpinner();
        Carousels.initialise()
        Filters.scrollHandler($)
        Filters.jobFiltersLocationClickHandler();
        Filters.postFiltersBtnClickHandler();
        Filters.jobFiltersCloseSalarySlider();
        StickyApply.initialise()
        JobTile.addLogo()
        JobTile.logoReplacer()
        JobTile.brandClassAssignment()
        JobTile.setActive()
        Modal.closeModalOnBgClick()
        PostTile.makePostTileClickable()
        ListWidget.checkIfJobTilesHaveProfile()
        SocialProfile.displayRecruiterIfAvailable()
        Footer.FooterHandlers()
        SearchOverlay.initialise()
        initializeVideoBannerModal()
        closeVideoModal()
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
    }
})
